import { CustomerSummaryInterface } from '@vendasta/billing';
import { Currency, currencyFromApi } from '../pricing';

export interface CustomerSummary {
  customerId: string;
  purchaseItemQuantity: number;
  purchaseItemTotal: number;
  currency: Currency;
}

export function customerSummaryFromApi(csApi: CustomerSummaryInterface): CustomerSummary {
  let currency;
  if (csApi.currency !== undefined) {
    currency = currencyFromApi(csApi.currency);
  }
  return {
    customerId: csApi.customerId || '',
    purchaseItemQuantity: csApi.purchaseItemQuantity || 0,
    purchaseItemTotal: csApi.purchaseItemTotal || 0,
    currency: currency || Currency.USD,
  };
}
